import React, { FC } from 'react';

import IconTime from '@/assets/time.svg?react';

interface Props {
  title: string;
  description: string;
}

const TrialInfo: FC<Props> = ({ title, description }) => {
  return (
    <div className="col-span-2 flex flex-col gap-y-2.5 rounded-md bg-gray-200 px-[14px] py-4 sm:p-6 lg:gap-y-6 lg:p-9">
      <div className="flex items-center gap-2">
        <IconTime className="w-5 text-blue-600" />
        <h3 className="h3">{title}</h3>
      </div>
      <p className="body-small">{description}</p>
    </div>
  );
};

export default TrialInfo;
